import { mapGetters } from 'vuex';

import moment from 'moment-timezone';
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';

import preloader from '@/components/preloader/index.vue';

import Api from '@/utils/api';

export default {
  components: {
    Multiselect,
    DatePicker,
    preloader,
  },
  props: {
    dateFilter: {
      type: Array,
      default () {
        return [null, null];
      },
    },
    params: {
      type: Object,
      selectClass: {
        type: Object,
        default: 'black',
      },
      showPreloader: {
        type: Boolean,
        default: true,
      },
      currentView: {
        type: String,
        default: 'tile',
      },
    },
  },
  data () {
    return {
      prefix: '/filters/',

      sourceLanguageList: [],
      targetLanguageList: [],
      industryList: [],
      documentTypeList: [],
      statusList: [],
      jobTypeList: [],

      paramsList: {
        source_language: null,
        target_language: null,
        created_on: null,
        due_date: null,
        industry: null,
        document_type: null,
        status: null,
        job_type: null,
      },

      nameUrlFilters: this.$route.name,
      baseFilterUrl: '',
      finalUrl: '',

      paramsUrl: {
        project_groups: 'projects',
        project_groups_filter: 'projects',
        projects: 'tasks',
        projects_filter: 'tasks',
        reports: 'reports',
        reports_filter: 'reports',
        jobs: 'jobs',
        jobs_filter: 'jobs',
      },
      queryUrl: {
        name: null,
        url: null,
      },

      load: true,
    };
  },
  computed: {
    ...mapGetters({
      showFilter: 'showFilter',
      userRole: 'userRole',
      user: 'user',
    }),
  },
  watch: {
    'paramsList.source_language' () {
      this.setUrlFilters();
    },
    'paramsList.target_language' () {
      this.setUrlFilters();
    },
    'paramsList.created_on' () {
      this.setUrlFilters();
    },
    'paramsList.due_date' () {
      this.setUrlFilters();
    },
    'paramsList.industry' () {
      this.setUrlFilters();
    },
    'paramsList.document_type' () {
      this.setUrlFilters();
    },
    'paramsList.status' () {
      this.setUrlFilters();
    },
    'paramsList.job_type' () {
      this.setUrlFilters();
    },
    dateFilter (newVal) {
      this.resetDateTimeSwitch();
    },
  },
  created () {
    this.baseFilterUrl = this.$route.path + this.prefix + this.paramsUrl[this.nameUrlFilters];
    this.getFiltersParams();
  },
  methods: {
    limitText (count) {
      return `and ${count} others`;
    },

    resetDateTimeSwitch () {
      this.paramsList.created_on = [];
      if (this.dateFilter.length !== 0) {
        if (this.dateFilter[0] == null) {
          this.paramsList.created_on = null;
        } else {
          this.paramsList.created_on[0] = Number(this.dateFilter[0] * 1000);
          this.paramsList.created_on[1] = Number(this.dateFilter[1] * 1000);
        }

        this.sendFilters();
      }
    },

    getFiltersParams () {
      Api.filters
        .get(this.paramsUrl[this.nameUrlFilters])
        .then(({ data }) => {
          this.load = false;
          const response = data;

          if (!response.Status) {
            this.load = false;
          }

          this.sourceLanguageList = response.Data.SLanguages;
          this.targetLanguageList = response.Data.TLanguages;
          this.industryList = response.Data.IndustryFields;
          this.documentTypeList = response.Data.TextCategories;
          this.statusList = response.Data.Steps;
          this.jobTypeList = response.Data.JobTypes;

          // If isset `filters` in url
          if (this.$route.path.indexOf('filters') != -1 && !this.$store.getters.filters.url) {
            const query = this.$route.query;

            this.baseFilterUrl = this.$route.path;

            if (Object.keys(query).length == 0) {
              this.queryUrl = {
                name: this.paramsUrl[this.nameUrlFilters] + '?',
                url: '',
              };
              return this.sendFilters();
            }

            const promise = new Promise((resolve, reject) => {
              resolve(this.getUrlFilters(query));
            });

            promise.then(() => {
              this.sendFilters();
            });

            // If isset in state
          } else if (this.$store.getters.filters.url) {
            if (this.$route.path.indexOf('filters') != -1) {
              this.baseFilterUrl = this.$route.path;
            }

            const urlParamsStore = this.$store.getters.filters.url.replace(/[\\#+()$~%'":*?<>{}]/g, '').split('&');
            const query = {};

            urlParamsStore.forEach((item) => {
              const parseUrl = item.split('=');
              query[parseUrl[0]] = parseUrl[1];
            });

            const promise = new Promise((resolve, reject) => {
              resolve(this.getUrlFilters(query));
            });

            promise.then(() => {
              this.sendFilters();
            });

            // If empty all
          } else {
            this.queryUrl = {
              name: this.paramsUrl[this.nameUrlFilters] + '?',
              url: '',
            };

            this.sendFilters();
          }
        });
    },

    // Get params from url|store
    getUrlFilters (paramsQuery) {
      for (const [name, value] of Object.entries(paramsQuery)) {
        if (name in this.paramsList) {
          this.setDefaultFilters(name, value);
        }
      }
    },

    // Set filters in url
    setUrlFilters () {
      let newUrl = '';

      for (const [name, value] of Object.entries(this.paramsList)) {
        if (value !== null) {
          if (typeof value === 'object' && value.length > 0) {
            if (name == 'source_language' ||
                            name == 'target_language' ||
                            name == 'industry' ||
                            name == 'document_type') {
              newUrl += name + '=' + value.map((item) => item.ID).join('|') + '&';
            }

            if (name == 'status' ||
                            name == 'job_type') {
              newUrl += name + '=' + value.map((item) => item.Name).join('|') + '&';
            }

            if (name == 'created_on' ||
                            name == 'due_date') {
              let addDate = true;

              value.forEach((item) => {
                (item === null || item === 0) ? addDate = false : addDate = true;
              });

              if (addDate) {
                newUrl += name + '=' + value.map((item) => moment(item).unix()).join(',') + '&';
              }
            }
          }
        }
      }

      this.queryUrl = {
        name: this.paramsUrl[this.nameUrlFilters] + '?',
        url: newUrl.slice(0, -1),
      };

      const historyUrl = newUrl === '' ? '' : '?' + newUrl.slice(0, -1);

      this.finalUrl = this.baseFilterUrl + historyUrl;
      this.$store.dispatch('SET_FILTERS', this.queryUrl);
    },

    // Set filters in different inputs
    setDefaultFilters (nameFilter, valueFilter) {
      this.$set(this.paramsList, nameFilter, []);

      if (valueFilter !== '') {
        if (nameFilter == 'source_language' ||
                    nameFilter == 'target_language' ||
                    nameFilter == 'industry' ||
                    nameFilter == 'document_type' ||
                    nameFilter == 'status' ||
                    nameFilter == 'job_type') {
          const parseVal = valueFilter.split('|');

          parseVal.forEach((item) => {
            let value;

            if (nameFilter == 'source_language') {
              value = this.sourceLanguageList.find((el) => el.ID === Number(item));
            }
            if (nameFilter == 'target_language') {
              value = this.targetLanguageList.find((el) => el.ID === Number(item));
            }
            if (nameFilter == 'industry') {
              value = this.industryList.find((el) => el.ID === Number(item));
            }
            if (nameFilter == 'document_type') {
              value = this.documentTypeList.find((el) => el.ID === Number(item));
            }
            if (nameFilter == 'status') {
              value = this.statusList.find((el) => el.Name === String(item));
            }
            if (nameFilter == 'job_type') {
              value = this.jobTypeList.find((el) => el.Name === String(item));
            }

            if (value) {
              this.paramsList[nameFilter].push(value);
            }
          });
        }

        if (nameFilter == 'created_on' ||
                    nameFilter == 'due_date') {
          const parseVal = valueFilter.split(',');

          this.paramsList[nameFilter] = parseVal.map((item) => Number(item) * 1000);
        }
      }
    },

    sendFilters () {
      this.baseFilterUrl = this.$route.path;
      this.setUrlFilters();

      const promise = new Promise((resolve, reject) => {
        resolve(this.$root.$emit('resetPagination', true));
      });

      promise.then(() => {
        this.$emit('updateFilters', this.queryUrl);
      });
      this.$router.push(this.finalUrl);
    },

    clearFilters () {
      const newUrl = this.baseFilterUrl.replace(this.prefix + this.paramsUrl[this.nameUrlFilters], '');

      for (const [name] of Object.entries(this.paramsList)) {
        this.paramsList[name] = null;
      }

      this.queryUrl = {
        name: this.paramsUrl[this.nameUrlFilters] + '?',
        url: '',
      };

      this.finalUrl = newUrl;
      this.$store.dispatch('CLEAR_FILTERS');
      this.sendFilters();
    },
  },
};
